module.exports = __webpack_public_path__ + "static/media/zuikaku-icon.85aef4af.png";